import React, { memo } from "react";
import { VStack, } from "../native-base";
// import styled from "styled-components/native";

export const Area = memo((props) => {
    return <VStack mt={8} { ...props } />
})